import { Button } from '@/components/ui/button'

export default function ArtifactsPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Artifacts Marketplace</h1>
      <p className="text-gray-500">Browse and purchase AI artifacts - coming soon</p>
    </div>
  )
}
